import React, { useEffect, useRef } from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    id: 1,
    name: 'Carlos Eduardo Silva',
    position: 'Diretor de Operações',
    company: 'Distribuidora Martins Ltda',
    location: 'São Paulo, SP',
    text: 'A MSA transformou completamente nosso armazém. A organização e segurança aumentaram significativamente, e conseguimos otimizar 40% do espaço disponível.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ana Paula Rodrigues',
    position: 'Gerente de Logística',
    company: 'Indústria Brasileira de Alimentos',
    location: 'Curitiba, PR',
    text: 'Excelente qualidade dos produtos e instalação impecável. A equipe é extremamente profissional e o prazo de entrega foi cumprido rigorosamente.',
    rating: 5
  },
  {
    id: 3,
    name: 'Roberto Mendes Santos',
    position: 'Proprietário',
    company: 'Autopeças Mendes',
    location: 'Belo Horizonte, MG',
    text: 'Trabalho com a MSA há 3 anos e sempre superam minhas expectativas. O suporte técnico é rápido e eficiente. Recomendo de olhos fechados!',
    rating: 5
  },
  {
    id: 4,
    name: 'Juliana Costa Ferreira',
    position: 'Coordenadora de Compras',
    company: 'Supermercados União',
    location: 'Rio de Janeiro, RJ',
    text: 'A solução apresentada pela MSA foi exatamente o que precisávamos. Nosso estoque ficou mais organizado e a produtividade da equipe aumentou consideravelmente.',
    rating: 5
  },
  {
    id: 5,
    name: 'Marcelo Oliveira Lima',
    position: 'Gerente Industrial',
    company: 'Metalúrgica Paulista S.A.',
    location: 'Campinas, SP',
    text: 'Estruturas robustas e de alta qualidade. O investimento valeu cada centavo. A MSA é referência em porta paletes no mercado nacional.',
    rating: 5
  },
  {
    id: 6,
    name: 'Patricia Almeida Souza',
    position: 'Diretora Administrativa',
    company: 'Farmácia Popular',
    location: 'Brasília, DF',
    text: 'Atendimento diferenciado desde o primeiro contato. A equipe entende nossas necessidades e oferece soluções personalizadas. Muito satisfeita com o resultado!',
    rating: 5
  }
];

function Testimonials() {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    // Observar seção principal
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Observar cada card
    cardsRef.current.forEach((card) => {
      if (card) observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials" ref={sectionRef}>
      <div className="testimonials__container">
        <div className="testimonials__header">
          <h2 className="testimonials__title">
            O que nossos <span className="testimonials__title--highlight">clientes dizem</span>
          </h2>
          <p className="testimonials__subtitle">
            Mais de 500 empresas confiam na MSA Porta Paletes para organizar seus estoques
          </p>
        </div>

        <div className="testimonials__grid">
          {testimonialsData.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="testimonial-card"
              ref={(el) => (cardsRef.current[index] = el)}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="testimonial-card__stars">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="testimonial-card__star">★</span>
                ))}
              </div>
              
              <p className="testimonial-card__text">"{testimonial.text}"</p>
              
              <div className="testimonial-card__author">
                <div className="testimonial-card__avatar">
                  {testimonial.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                </div>
                <div className="testimonial-card__info">
                  <h4 className="testimonial-card__name">{testimonial.name}</h4>
                  <p className="testimonial-card__position">{testimonial.position}</p>
                  <p className="testimonial-card__company">{testimonial.company}</p>
                  <p className="testimonial-card__location">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
